module.exports = __webpack_public_path__ + "static/media/suspiciousActivity.5762dbcb.m4a";